import Vue from 'vue';

export default {
    install(Vue, store) {

        class ResultData {

            constructor() {
                this.result = {
                    m: {
                        wealth: [
                            [
                                'ending_w_1_1.png',
                                'ending_w_2_1m.png',
                                'ending_w_3_1.png',
                            ],
                            [
                                'ending_w_1_2m.png',
                                'ending_w_2_2.png',
                                'ending_w_3_2m.png',
                            ]
                        ],
                        health: [
                            [
                                'ending_h_1_1m.png',
                                'ending_h_2_1.png',
                                'ending_h_3_1.png',
                            ],
                            [
                                'ending_h_1_2m.png',
                                'ending_h_2_2.png',
                                'ending_h_3_2m.png',
                            ],
                        ],
                        relationship: [
                            [
                                'ending_r_1_2.png',
                                'ending_r_2_2.png',
                                'ending_r_3_2m.png',
                            ],
                            [
                                'ending_r_1_1.png',
                                'ending_r_2_1.png',
                                'ending_r_3_1m.png',
                            ],
                        ],
                        honor: [
                            [
                                'ending_o_1_1m.png',
                                'ending_o_2_1m.png',
                                'ending_o_3_1.png',
                            ],
                            [
                                'ending_o_1_2m.png',
                                'ending_o_2_2m.png',
                                'ending_o_3_2.png',
                            ],
                        ],
                    },
                    f: {
                        wealth: [
                            [
                                'ending_w_1_1.png',
                                'ending_w_2_1f.png',
                                'ending_w_3_1.png',
                            ],
                            [
                                'ending_w_1_2f.png',
                                'ending_w_2_2.png',
                                'ending_w_3_2f.png',
                            ]
                        ],
                        health: [
                            [
                                'ending_h_1_1f.png',
                                'ending_h_2_1.png',
                                'ending_h_3_1.png',
                            ],
                            [
                                'ending_h_1_2f.png',
                                'ending_h_2_2.png',
                                'ending_h_3_2f.png',
                            ],
                        ],
                        relationship: [
                            [
                                'ending_r_1_2.png',
                                'ending_r_2_2.png',
                                'ending_r_3_2f.png',
                            ],
                            [
                                'ending_r_1_1.png',
                                'ending_r_2_1.png',
                                'ending_r_3_1f.png',
                            ],
                        ],
                        honor: [
                            [
                                'ending_o_1_1f.png',
                                'ending_o_2_1f.png',
                                'ending_o_3_1.png',
                            ],
                            [
                                'ending_o_1_2f.png',
                                'ending_o_2_2f.png',
                                'ending_o_3_2.png',
                            ],
                        ],
                    }
                }
            }

            urlPrefix(type) {
                if (type === 'result') {
                    return 'https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/result/'
                } else {
                    return 'https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/ending/'
                }
            }

            factor1(gender, factor1, index, type) {

                gender = gender.toLowerCase()
                const grade = factor1 <= 49 ? 2 : (factor1 > 75 ? 0 : 1)

                return this.urlPrefix(type) + this.result[gender]['wealth'][index][grade]
            }

            factor2(gender, factor2, index, type) {

                gender = gender.toLowerCase()
                const grade = factor2 <= 49 ? 2 : (factor2 > 75 ? 0 : 1)

                return this.urlPrefix(type) + this.result[gender]['health'][index][grade]
            }

            factor3(gender, factor3, index, spouse, hasBaby, type) {


                gender = gender.toLowerCase()

                let grade = 0
                if (index === 1) {
                    if (spouse) {
                        if (hasBaby) {
                            grade = 1
                        } else {
                            grade = 0
                        }
                    } else {
                        grade = 2
                    }
                } else {
                    grade = factor3 <= 49 ? 2 : (factor3 > 75 ? 0 : 1)
                }

                return this.urlPrefix(type) + this.result[gender]['relationship'][index][grade]
            }

            factor4(gender, factor4, index, type) {

                gender = gender.toLowerCase()
                const grade = factor4 <= 49 ? 2 : (factor4 > 75 ? 0 : 1)

                return this.urlPrefix(type) + this.result[gender]['honor'][index][grade]
            }
        }


        Vue.prototype.$resultData = new ResultData()

    }
};
